export const MAC_ADDRESS = /^(([0-9A-Fa-f]{2})|([0-9A-Fa-f]{2})){5}([0-9A-Fa-f]{2})$/;
export const INTEGER_ONLY = /^[0-9]*$/;
export const UUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
export const CRM_ID = /^[A-Za-z0-9]{18}$/;
